import ApiSistema from '@/core/apis/ApiSistema';
import { IOficio } from '@/models/Entidades/IOficio';
import { IResposta } from '@/core/models/IResposta';
import { IServicoBase } from '@/core/models/IServicoBase';
import { IRepostaConsulta } from '@/core/models/IRepostaConsulta';
import { IOficioParametrosConsulta } from '@/models/ParametrosRequisicao/Consulta/IOficioParametrosConsulta';
import { IDTOOficio } from '@/models/DTO/IDTOOficio';
import { IParametrosBuscaRapida } from '@/core/models/Consulta/IParametrosBuscaRapida';
import { IItemBuscaRapida } from '@/core/models/Consulta/IItemBuscaRapida';
import { EStatusOficio } from '@/models/Enumeradores/EStatusOficio';
import { IRetornoRelatorio } from '@/core/models/IRetornoRelatorio';
/**
 * Serviço de Oficios
 */

class ServicoOficio implements IServicoBase<IOficio> {
  endPoint = 'oficios';

  apiSistema = new ApiSistema();

  public async incluir(oficio: IOficio): Promise<IResposta> {
    const result: any = await this.apiSistema.post(`${this.endPoint}`, oficio);
    return result.data;
  }

  public async gerarPdf(codigo:number): Promise<IRetornoRelatorio> {
    const result: any = await this.apiSistema.post(`${this.endPoint}/${codigo}/imprimir`);
    return result.data;
  }

  public async atualizar(oficio: IOficio): Promise<IResposta> {
    const result: any = await this.apiSistema.put(`${this.endPoint}/${oficio.codigo}`, oficio);
    return result.data;
  }

  public async obter(codigo: number): Promise<IOficio> {
    const result: any = await this.apiSistema.get(`${this.endPoint}/${codigo}`);
    return result.data;
  }

  public async obterOficios(parametrosConsulta: IOficioParametrosConsulta): Promise<IRepostaConsulta<IDTOOficio>> {
    let parametrosAdicionais = '';

    if (parametrosConsulta.valorPesquisa !== undefined) {
      parametrosAdicionais += `?ValorPesquisa=${parametrosConsulta.valorPesquisa}`;
    }

    if (parametrosConsulta.numeroPagina !== undefined && parametrosConsulta.numeroPagina > 0) {
      parametrosAdicionais += (parametrosAdicionais !== '' ? '&' : '?');
      parametrosAdicionais += `NumeroPagina=${parametrosConsulta.numeroPagina}`;
    }
    if (parametrosConsulta.qtdeRegistrosPagina !== undefined && parametrosConsulta.qtdeRegistrosPagina > 0) {
      parametrosAdicionais += (parametrosAdicionais !== '' ? '&' : '?');
      parametrosAdicionais += `QtdeRegistrosPagina=${parametrosConsulta.qtdeRegistrosPagina}`;
    }
    if (parametrosConsulta.qtdeRegistrosTotal !== undefined && parametrosConsulta.qtdeRegistrosTotal > 0) {
      parametrosAdicionais += (parametrosAdicionais !== '' ? '&' : '?');
      parametrosAdicionais += `QtdeRegistrosTotal=${parametrosConsulta.qtdeRegistrosTotal}`;
    }
    if (parametrosConsulta.ordenacao !== undefined) {
      parametrosConsulta.ordenacao.forEach((item) => {
        parametrosAdicionais += (parametrosAdicionais !== '' ? '&' : '?');
        parametrosAdicionais += `Ordenacao=${item}`;
      });
    }
    if (parametrosConsulta.codigos !== undefined) {
      parametrosConsulta.codigos.forEach((codigo) => {
        parametrosAdicionais += (parametrosAdicionais !== '' ? '&' : '?');
        parametrosAdicionais += `Codigos=${codigo}`;
      });
    }
    const result: any = await this.apiSistema.get(`${this.endPoint}${parametrosAdicionais}`);
    return result.data;
  }

  public async buscaRapida(parametrosConsultaRapida: IParametrosBuscaRapida): Promise<IItemBuscaRapida[]> {
    const parametros = this.apiSistema.obterParametrosBuscaRapida(parametrosConsultaRapida);
    const result: any = await this.apiSistema.get(`${this.endPoint}/busca-rapida${parametros}`);
    return result.data;
  }

  public async deletar(codigo: number): Promise<IResposta> {
    const result: any = await this.apiSistema.delete(`${this.endPoint}/${codigo}`);
    return result.data;
  }

  public obterNomeStatus(status: EStatusOficio): string {
    let nomeStatus = '';
    switch (status) {
      case EStatusOficio.EmDigitacao:
        nomeStatus = 'Em digitação';
        break;

      case EStatusOficio.Autorizado:
        nomeStatus = 'Autorizado';
        break;

      case EStatusOficio.Excluido:
        nomeStatus = 'Excluido';
        break;

      default:
        break;
    }

    return nomeStatus;
  }
}

export default ServicoOficio;
